import * as types from "../../mutationTypes";
import invoiceDataService from "services/invoiceDataService";

const actions = {
  async setFilter ({ commit }, filter) {
    await commit(types.INVOICE_DATA_FILTER, filter);
  },
  async findByFilter ({ dispatch }, filter) {
    await dispatch('setFilter', filter);
    await dispatch('findCurrent');
  },
  async findCurrent({ commit, state, dispatch }) {
    await commit(types.INVOICE_DATA_CURRENT, {
      invoiceData: null
    });
    dispatch('app/loadingDataEnable', 'invoiceData', {root: true});
    const invoiceData = await invoiceDataService.findByFilter(state.filter);
    await commit(types.INVOICE_DATA_CURRENT, {
      invoiceData: invoiceData
    });
    dispatch('app/loadingDataDisable', 'invoiceData', {root: true});
  }
};

export default actions;



// WEBPACK FOOTER //
// ./client/store/modules/invoiceData/invoiceDataActions.js